import {
  useAppName,
  useUser,
  useOperatingContext,
  segment,
} from "@granular/fabric3-core";
import { datadogRum } from "@datadog/browser-rum";
import { useState, useEffect } from "react";
import { getAppMetadata } from "../helpers/appData.helpers";

const isLocalhost = import.meta.url.includes("localhost");

/**
 * Namespace → team lookup built at module level from each app's package.json.
 * Used to tag Datadog RUM errors with the owning team.
 */
const appTeamMap = new Map(
  getAppMetadata(isLocalhost).map(([namespace, pkg]) => [
    namespace,
    pkg.fabric3.team,
  ]),
);

/**
 * This component should be run ONCE from within the container. It tracks
 * when users navigate between apps.
 */
export const AppTracking = () => {
  const currentApp = useAppName();
  const granularID = useUser().data?.granularId;
  const role = useOperatingContext()?.contextSelected?.role;
  const [lastAppName] = useState(currentApp ?? "");

  useEffect(() => {
    const team = appTeamMap.get(currentApp ?? "");
    datadogRum.setGlobalContextProperty(
      "team",
      team?.toLowerCase() ?? "unknown",
    );
  }, [currentApp]);

  useEffect(() => {
    switch (currentApp) {
      case "profile": {
        void segment.track("navigate to My Profile", {
          currentApp: lastAppName,
        });
        break;
      }
      default: {
        void segment.track(`navigate to ${currentApp}`, {
          currentApp: lastAppName,
          granularID,
          role,
          date: new Date().toISOString(),
        });
        break;
      }
    }
  }, [currentApp, lastAppName, role, granularID]);

  return null;
};
